enum ActionTypes {
  FILTERS_LOAD = "FILTERS/LOAD",
  FILTERS_ADD = "FILTERS/ADD",
  FILTERS_ADD_SUCCESS = "FILTERS/ADD/SUCCESS",
  FILTERS_REMOVE = "FILTERS/ERROR",
  FILTERS_RESET = "FILTERS/RESET",
}

export const FILTERS_TYPES = {
  ...ActionTypes,
};
